const handleTimeChange = (event, date, setDate) => {
    const selectedTime = event.target.value;
    const [hours, minutes] = selectedTime.split(':');
    const updatedDate = new Date(date);
    updatedDate.setHours(parseInt(hours), parseInt(minutes));
    setDate(updatedDate);
};

export default handleTimeChange;